import Plane from "./plane.js";

export default Plane;
